import { useAuiState } from '@assistant-ui/react'
import { createContext, useContext } from 'react'

/** Work the host knows about that assistant-ui's `thread.isRunning` cannot see —
 * a server-side run narrating into the thread, or the fetch that settles a
 * finished turn. `AgentThread` shows it in the composer footer as the thread's
 * activity row; without a provider the row only reflects the thread's own run. */
export interface AgentActivity {
  label: string
  /** Secondary text after the label — the current tool, a phase. */
  detail?: string
  /** ISO start of the work; the row shows the elapsed time when set. */
  startedAt?: string
}

export const AgentActivityContext = createContext<AgentActivity | null>(null)

export function useAgentActivity(): AgentActivity | null {
  return useContext(AgentActivityContext)
}

/** Whether anything is working on the thread: its own run, or activity the host
 * reports. Per-message controls that would start a turn (reload, retry) stay out
 * of the way while it is — a turn posted into a locked schema session is refused. */
export function useThreadBusy(): boolean {
  const reported = useAgentActivity()
  const isRunning = useAuiState(s => s.thread.isRunning)
  return isRunning || reported !== null
}
